const o = "14px", s = 'Font Roboto, "Roboto fallback", sans-serif', n = "Roboto Condensed,Roboto Condensed fallback, sans-serif", a = 'Merriweather, "Merriweather fallback", serif', e = "Barlow, sans-serif", t = "Barlow Condensed, Roboto Condensed, Roboto Condensed fallback, sans-serif", r = "Barlow Semi Condensed, Roboto Condensed,Roboto Condensed fallback", i = "Playfair Display, serif", f = "Angkor, verdana", d = "Fredoka, sans-serif", l = "Heebo, sans-serif", b = "Bodoni Moda, serif", c = "Indivisible Variable, sans-serif", C = "Noto Sans SC, sans-serif", k = "Mixta Sharp, sans-serif", R = "Mixta Pro, sans-serif";
export {
  n as a,
  a as b,
  e as c,
  o as d,
  t as e,
  s as f,
  r as g,
  i as h,
  f as i,
  d as j,
  l as k,
  b as l,
  c as m,
  C as n,
  k as o,
  R as p
};
//# sourceMappingURL=variables-BSQ2K9t-.mjs.map
